import { Injectable } from '@angular/core';
import { Device } from '@era/locations-sdk';
import { DeviceStoreActions, LocationsRouterStoreSelectors, RouterStoreStates } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class DeviceResolver {
  constructor(
    private readonly deviceStore: Store<Device>,
    private readonly routerStore: Store<RouterStoreStates.RouterState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(LocationsRouterStoreSelectors.selectBrandId).pipe(
      withLatestFrom(this.routerStore.select(LocationsRouterStoreSelectors.selectLocationId)),
      tap(([brandId, locationId]) => {
        this.deviceStore.dispatch(
          DeviceStoreActions.DeviceResolverActions.devicesRequested({
            brandId,
            locationId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
